import Environment from '../common/Environment';
import Group from '../entities/Group';
import Member from '../entities/Member';
import GroupsJson from '../jsons/GroupsJson';

export default class GetGroupsAll {
  execute(account: Member): Promise<Group[]> {
    const method = 'GET';
    const path: string = '/groups/all';

    return new Promise((resolve, reject) => {
      const request = new URL(Environment.server() + path);
      const params = new URLSearchParams();
      params.append('t', account.token);
      request.search = params.toString();

      fetch(request.toString(), {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: GroupsJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.groups);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/GetGroupsAll.ts